import React, { Fragment, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose, withApollo } from 'react-apollo';

import useFetchTeacherAssignments from 'chameleon/ui-stack/hooks/use-assignments-fetch/teacher';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { STATUS } from 'chameleon-src/constants/assessmentStatus';
import { BreadcrumbContext } from 'chameleon/ui-stack/ui/basic/breadcrumbs';
import { pathBreadCrumbMapping } from 'chameleon/src/components/results/utils/utils';
import { isNil } from 'lodash';
import { findQBSubject } from '../learnosity/utils/helpers';

const ProgressContainer = (props) => {
  const { params, userSubjects, children, router, classes } = props;
  const subjectInfo = findQBSubject(userSubjects, params.subject);

  if (!subjectInfo) {
    return null;
  }

  const [learnositySignedRequest, setLearnositySignedRequest] = useState(null);
  const [options, setOptions] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState();

  const { queryParams, location } = useNavigation({
    router,
  });

  const { subject } = params;
  const { type: resourceType = '' } = queryParams || {};
  const status = STATUS.ALL_ASSIGNED;

  const [getTeacherAssignments] = useFetchTeacherAssignments();
  const sections = classes ? classes.items.map((clazz) => clazz.name) : [];

  const loadAssignments = () => {
    const fetchProps = {
      subject,
      status,
      resourceType,
      learnositySignedRequest,
      setData,
      setOptions,
      setLearnositySignedRequest,
      setLoading,
      sections,
      setHasPaperscore: () => {},
    };
    getTeacherAssignments({ ...fetchProps });
  };

  const { breadCrumbs, dispatch, ACTIONS } = useContext(BreadcrumbContext);
  useEffect(() => {
    const breadcrumbText = pathBreadCrumbMapping.AssignmentProgress;
    const breadCrumbItem = breadCrumbs.find(
      (crumb) => crumb.text === breadcrumbText,
    );
    if (!breadCrumbItem && !isNil(breadcrumbText)) {
      const payload = {
        to: location.pathname,
        text: breadcrumbText,
      };
      dispatch({ type: ACTIONS.addBreadCrumb, payload });
    }
  }, [location, breadCrumbs]);

  useEffect(() => {
    loadAssignments();
  }, [status, resourceType]);
  return !isLoading && data ? (
    <Fragment>
      {React.cloneElement(children, {
        options,
        assessments: data,
        subjectInfo,
      })}
    </Fragment>
  ) : (
    <LoadingSpinner />
  );
};

const mapStateToProps = ({ userSubjects, classes }) => ({
  userSubjects,
  classes,
});

export default compose(
  withApollo,
  connect(mapStateToProps, {}),
)(ProgressContainer);
